import {inject} from '@angular/core';
import {TranslateHelper} from '@binotel-frontend/bnt-common-components';
import {EPhoneUpdateSteps} from '@entities/settings';
import {Actions, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {SnackbarHelper} from '@shared/helper';
import {createFunctionalEffect} from '@shared/utils/effects.helper';
import {settingsFeature} from '@state/settings/settings.feature';
import {mapOdApiActions} from '@utils/map-od-api-actions.function';
import {map, switchMap, withLatestFrom} from 'rxjs';

import {SettingsActions} from './settings.actions';
import {SettingsApi} from './settings.api';

export namespace SettingsEffects {
  export const updatePhone$ = createFunctionalEffect(
    (actions$ = inject(Actions), api = inject(SettingsApi)) =>
      actions$.pipe(
        ofType(SettingsActions.updateUsersPhone.requested),
        switchMap(({payload}) =>
          api
            .updateUser(payload)
            .pipe(mapOdApiActions(SettingsActions.updateUsersPhone))
        )
      )
  );

  export const processUpdate$ = createFunctionalEffect(
    (actions$ = inject(Actions), store = inject(Store)) =>
      actions$.pipe(
        ofType(SettingsActions.updateUsersPhone.succeeded),
        withLatestFrom(
          store.select(settingsFeature.selectCurrentPhoneUpdateStep)
        ),
        map(([, currentUpdateStep]) => {
          let nextStep;

          switch (currentUpdateStep) {
            case EPhoneUpdateSteps.Step1:
              nextStep = EPhoneUpdateSteps.Step2;
              break;
            case EPhoneUpdateSteps.Step2:
              nextStep = EPhoneUpdateSteps.Step3;
              break;
            case EPhoneUpdateSteps.Step3:
              nextStep = EPhoneUpdateSteps.Step4;
              break;
            case EPhoneUpdateSteps.Step4:
              nextStep = EPhoneUpdateSteps.Step1;
              SnackbarHelper.open(
                TranslateHelper.translate('common.operation-successful')
              );
              break;
            default:
              nextStep = EPhoneUpdateSteps.Step1;
          }

          return SettingsActions.setCurrentPhoneStep({
            to: nextStep,
          });
        })
      )
  );
}
